import { Grid, Typography } from "@mui/material";
import type { TransactionDirection } from "Infrastructure/Api/Api";
import { DirectionFilterDropdown } from "Components/Transactions/TransactionsSearchBar/TransactionFilters/DirectionFilterDropdown";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Transactions.Filters;

type Props = {
  value?: TransactionDirection;
  onChange: (value: TransactionDirection | undefined) => void;
};

export const DirectionFilter = ({ value, onChange }: Props) => {
  const { t } = useResource();

  return (
    <Grid size={{ xs: 12, sm: 6 }}>
      <Typography fontSize={13} fontWeight={400} mb={1}>
        {t(RESOURCES.Direction)}
      </Typography>
      <DirectionFilterDropdown value={value} onChange={onChange} />
    </Grid>
  );
};
